/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers{
    interface IFormContainerScope extends angular.IScope {
        model:warsApp.models.FormContainerModel;
    }
    export class FormContainerController {
        constructor(
            $scope: IFormContainerScope,
            private formContainerService: services.FormContainerService,
            private formService: services.FormService,
            $routeParams: angular.route.IRouteParamsService,
            deleteService: services.DeleteService,
            systemLevelService: services.SystemLevelService,
            securityMatrixService: services.SecurityMatrixService)
        {
            var processId = $routeParams["id"];

            $scope.model = new warsApp.models.FormContainerModel(
                formContainerService,
                formService,
                deleteService,
                systemLevelService,
                securityMatrixService,
                processId);
        }
    }
}

warsApp.registerController('FormContainerController',
    ['$scope', 'formContainerService', 'formService', '$routeParams', 'deleteService', "systemLevelService", "securityMatrixService"]);